export const PAGE_SIZES = [10, 20, 50, 100];
export const getAvailablePageSizes = (totalRecords) => {
    return PAGE_SIZES.filter((size) => size <= Math.max(totalRecords, PAGE_SIZES[0]));
};
